import React from "react";
import PropTypes from "prop-types";
import { IntlPropType } from "root/libs/core-libs/src";
import { DhlIcon, DhlIconWrapper } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";

import payByCash from "iconsTwoColors/cx/pay-by-cash.svg";
import payByIdeal from "iconsTwoColors/cx/pay-by-ideal.svg";
import payByInvoice from "iconsTwoColors/cx/pay-by-invoice.svg";
import payByDiscover from "iconsTwoColors/cx/pay-by-discover.svg";
import payByMastercard from "iconsTwoColors/cx/pay-by-mastercard.svg";
import payByPaypal from "iconsTwoColors/cx/pay-by-paypal.svg";
import payByVisa from "iconsTwoColors/cx/pay-by-visa.svg";
import payByAmex from "iconsTwoColors/cx/pay-by-amex.svg";
import payByDiners from "iconsTwoColors/cx/pay-by-diners.svg";
import payByJCB from "iconsTwoColors/cx/pay-by-jcb.svg";
import payByKlarnaSofort from "iconsTwoColors/cx/pay-by-klarna-sofort.svg";
import payByMaestro from "iconsTwoColors/cx/pay-by-maestro.svg";
import payByUnionPay from "iconsTwoColors/cx/pay-by-union-pay.svg";
import payByVisaElectron from "iconsTwoColors/cx/pay-by-visa-electron.svg";
import payByGiroPay from "iconsTwoColors/cx/pay-by-giropay.svg";
import payBySepa from "iconsTwoColors/cx/pay-by-sepa.svg";
import payByCOD from "iconsTwoColors/cx/pay-by-cod.svg";
import payByEprzelewy from "iconsTwoColors/cx/pay-by-eprzelewy.svg";
import payByMada from "iconsTwoColors/cx/pay-by-mada.svg";
import payByNordea from "iconsTwoColors/cx/pay-by-nordea.svg";
import PayByBancontact from "../OfferPaymentIcons/PayByBancontact";
import PayByBLIK from "../OfferPaymentIcons/PayByBLIK";

const paymentMethodsLogos = {
  CASH: payByCash,
  IDEAL: payByIdeal,
  MASTERCARD: payByMastercard,
  PAYPAL: payByPaypal,
  VISA: payByVisa,
  AMEX: payByAmex,
  DISCOVER: payByDiscover,
  INVOICE: payByInvoice,
  DINERS: payByDiners,
  JCB: payByJCB,
  MAESTRO: payByMaestro,
  KLARNA_SOFORT: payByKlarnaSofort,
  UNION_PAY: payByUnionPay,
  VISA_ELECTRON: payByVisaElectron,
  GIROPAY: payByGiroPay,
  SEPA: payBySepa,
  COD: payByCOD,
  EP: payByEprzelewy,
  MAD: payByMada,
  NO: payByNordea,
};

function getCopy(intl, id, values) {
  return intl.formatMessage({ id }, values);
}

export function getPaymentLabel(intl, copyPrefix, paymentMethod) {
  const copyKey = `${copyPrefix}.${paymentMethod.toLowerCase()}`;
  // eslint-disable-next-line no-extra-boolean-cast
  return !!intl.messages[copyKey] ? getCopy(intl, copyKey) : paymentMethod;
}

const ICON_WRAPPER_SIZE_BY_METHOD = {
  VISA: Sizes.LG,
  GIROPAY: Sizes.LG,
  SEPA: Sizes.LG,
  AMEX: Sizes.SM,
  KLARNA_SOFORT: Sizes.LG,
  UNION_PAY: Sizes.MD,
  MAD: Sizes.LG,
  NO: Sizes.XL,
  IDEAL: Sizes.MD,
  DISCOVER: Sizes.MD,
  MASTERCARD: Sizes.MD,
  PAYPAL: Sizes.SM,
  INVOICE: Sizes.SM,
  DINERS: Sizes.MD,
  JCB: Sizes.MD,
  MAESTRO: Sizes.MD,
  VISA_ELECTRON: Sizes.MD,
  CASH: Sizes.SM,
  COD: Sizes.MD,
  EP: Sizes.MD,
};

function getIconSrc(method) {
  return paymentMethodsLogos[method] || paymentMethodsLogos[method];
}

export function PaymentLogo({ intl, paymentMethod, copyPrefix }) {
  if (paymentMethod === "BANCONTACT") return <PayByBancontact />;
  if (paymentMethod === "BLIK") {
    return <PayByBLIK />;
  }

  const label = getPaymentLabel(intl, copyPrefix, paymentMethod);
  const src = getIconSrc(paymentMethod);

  const wrapperStyle = {
    display: "inline-flex",
    alignItems: "center",
    marginRight: paymentMethod === "INVOICE" ? "4px" : undefined,
    lineHeight: 0,
  };

  const size = ICON_WRAPPER_SIZE_BY_METHOD[paymentMethod] || Sizes.MD;
  return (
    <span style={wrapperStyle} role="img" aria-label={label}>
      <DhlIconWrapper size={size} dataAriaHidden="true">
        <DhlIcon>
          <svg viewBox={`${src.viewBox}`}>
            <use xlinkHref={`#${src.id}`} />
          </svg>
        </DhlIcon>
      </DhlIconWrapper>
    </span>
  );
}

PaymentLogo.propTypes = {
  intl: IntlPropType.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  copyPrefix: PropTypes.string.isRequired,
};
